import * as firebase from "firebase/app";

/**
 * Use Firebase /sessions endpoint to excange an SDKv2 authentication token for one that works
 * with SDKv3.  This is required to use the latest Firebase NPM Package
 *
 * https://github.com/firebase/firebase-auth-migration-helpers/blob/master/web/migrate.js
 *
 * @param legacyToken
 * @returns {Promise}
 */

export const exchangeFirebaseToken = legacyToken => {
  /* global FIREBASE_NAMESPACE */
  var url = "https://auth.firebase.com/v2/" + FIREBASE_NAMESPACE + "/sessions";
  return new Promise((resolve, reject) => {
    var req = new XMLHttpRequest();
    req.responseType = "json";
    req.onreadystatechange = () => {
      if (req.readyState !== req.DONE) {
        return;
      }
      if (req.status !== 200) {
        reject(new Error("invalid-user-token", "Invalid auth token."));
        return;
      }
      var newToken = req.response.token;
      if (!newToken) {
        reject(
          new Error("network-request-failed", "Invalid response from Firebase.")
        );
        return;
      }
      resolve(newToken);
    };
    req.onerror = () => {
      reject(
        new Error("network-request-failed", "Unable to verify auth token.")
      );
    };
    req.open("POST", url, true);
    req.setRequestHeader("Content-Type", "application/json");
    req.send(JSON.stringify({ token: legacyToken }));
  });
};

export const getFirebaseMajorVersion = () => {
  return firebase.SDK_VERSION.split(".")[0];
};

export const getFirebaseRef = (firebaseApp, path) => {
  if (getFirebaseMajorVersion() === "2") {
    return firebaseApp.child(path);
  }
  return firebaseApp.database().ref(path);
};

export const authWithCustomTokenPromise = (app, token) => {
  return new Promise((resolve, reject) => {
    app
      .auth()
      .signInWithCustomToken(token)
      .then(authResponse => resolve(authResponse.user))
      .catch(reject);
  });
};

export const checkFirebaseAuthStatePromise = firebaseApp =>
  new Promise((resolve, reject) => {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (user) {
        resolve(user);
      } else {
        resolve();
      }
    }, reject);
  });

/**
 * Tells firebase not to store auth data in user's browser
 */
export const disableFirebaseLocalStorage = async () => {
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);
};
